import { useBootstrap } from "@/features/bootstrap";
import { ROLES } from "@/features/router/roles";

export function useAppAccess() {
  const { data: bootstrap } = useBootstrap();

  const access = bootstrap?.access ?? null;
  const role = bootstrap?.role ?? null;

  const isStudent = role === ROLES.STUDENT;

  const hasStarted = (restriction) => {
    if (!restriction?.startsAt) return true;
    return new Date(restriction.startsAt) <= new Date();
  };

  const rawDistrict = access?.districtRestriction ?? null;
  const rawSchool = access?.schoolRestriction ?? null;

  const districtRestriction =
    rawDistrict && hasStarted(rawDistrict) ? rawDistrict : null;
  const schoolRestriction =
    rawSchool && hasStarted(rawSchool) ? rawSchool : null;

  const activeRestriction = districtRestriction ?? schoolRestriction ?? null;

  const isPaused =
    isStudent && !!access && !access.enabled && !!activeRestriction;

  const hasAnyPause =
    !isStudent && !!(districtRestriction || schoolRestriction);

  return {
    isPaused,
    hasAnyPause,
    access,
    activeRestriction,
    districtRestriction,
    schoolRestriction,
    role,
  };
}
